import { PageHeader } from '@sorare/core/src/components/navigation/PageHeader';
import { ANY_SPORT_MARKET } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsMobileApp } from '@sorare/core/src/hooks/useIsMobileApp';
import { navLabels } from '@sorare/core/src/lib/glossary';

import { IosHeader } from '../IosHeader';

export const MarketShopHeader = () => {
  const { generateSportContextPath } = useSportContext();
  const { isIosApp } = useIsMobileApp();

  if (isIosApp) {
    return (
      <IosHeader
        to={generateSportContextPath(ANY_SPORT_MARKET)}
        text={navLabels.shop}
      />
    );
  }
  return (
    <PageHeader
      text={navLabels.shop}
      backTo={generateSportContextPath(ANY_SPORT_MARKET)}
      disableBackBrowser
    />
  );
};
